import React, { PureComponent } from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Sector
} from "recharts";
import { Card, CardHeader, CardBody } from "shards-react";

const renderActiveShape = props => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fill="#333"
      >{`${payload.name}`}</text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fill="#999"
      >
        {`(${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};

const COLORS = [
  "#0DD1A9",
  "#0DAFD1",
  "#EEC13E",
  "#FF4545",
  "#A345FF",
  "#2577D5",
  "#8884d8",
  "#BBBBBB",
  "#ff8b45"
];

export default class ViewsLanguageChart extends PureComponent {
  static jsfiddleUrl = "https://jsfiddle.net/alidingling/Lrffmzfc/";

  onPieEnter = (data, index) => {
    this.setState({
      activeIndex: index
    });
  };

  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.state = {
      activeIndex: 0
    };
  }

  render() {
    const { title } = this.props;

    if (this.props.data.length === 0) {
      return (
        <Card small className="h-100">
          <CardHeader className="border-bottom">
            <h6 className="m-0">{title}</h6>
          </CardHeader>
          <CardBody className="pt-0">
            <div className="text-center" style={{ width: "100%", height: 570 }}>
              <strong className="centered error-text">
                Información no disponible
              </strong>
            </div>
          </CardBody>
        </Card>
      );
    } else {
      return (
        <Card small className="h-100">
          <CardHeader className="border-bottom">
            <h6 className="m-0">{title}</h6>
          </CardHeader>
          <CardBody className="pt-0">
            <div style={{ width: "100%", height: 600 }}>
              <ResponsiveContainer>
                <PieChart>
                  <Pie
                    data={this.props.data}
                    activeIndex={this.state.activeIndex}
                    activeShape={renderActiveShape}
                    innerRadius={80}
                    outerRadius={100}
                    fill="#8884d8"
                    dataKey="totalViews"
                    onMouseEnter={this.onPieEnter}
                  >
                    {this.props.data.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                        unit="%"
                      />
                    ))}
                  </Pie>
                  <Legend
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                  />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </CardBody>
        </Card>
      );
    }
  }
}
